module.exports = __webpack_public_path__ + "assets/img/learn_finish.e5a45b9b.png";